var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlass4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3176 44C7.95763 44 6.27763 38.94 8.99763 32.78L17.4976 13.48H16.8976C15.5976 13.48 14.3976 12.96 13.5376 12.1C12.6576 11.24 12.1376 10.04 12.1376 8.74C12.1376 6.14 14.2576 4 16.8776 4H31.0976C32.4176 4 33.5976 4.54 34.4576 5.4C35.5776 6.52 36.1376 8.16 35.7176 9.9C35.1776 12.06 33.0976 13.48 30.8776 13.48H30.5576L38.9976 32.8C41.6976 38.96 39.9376 44 31.6576 44H16.3176Z",
    stroke: "#219EBC",
    strokeWidth: 2.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8828 26.2397C11.8828 26.2397 18.0028 25.9997 24.0028 27.9997C30.0028 29.9997 35.6628 26.2197 35.6628 26.2197",
    stroke: "#219EBC",
    strokeWidth: 2.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlass4);
export default __webpack_public_path__ + "static/media/glass4.d7bfc37d895a5c7d332d56c99dd285d0.svg";
export { ForwardRef as ReactComponent };